
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * This file should be your main import to use Prisma-related types and utilities in a browser. 
 * Use it to get access to models, enums, and input types.
 * 
 * This file does not contain a `PrismaClient` class, nor several other helpers that are intended as server-side only.
 * See `client.ts` for the standard, server-side entry point.
 *
 * 🟢 You can import this file directly.
 */

import * as Prisma from './internal/prismaNamespaceBrowser'
export { Prisma }
export * as $Enums from './enums'
export * from './enums';
/**
 * Model Workplace
 * 
 */
export type Workplace = Prisma.WorkplaceModel
/**
 * Model Instance
 * 
 */
export type Instance = Prisma.InstanceModel
/**
 * Model InstanceActivity
 * 
 */
export type InstanceActivity = Prisma.InstanceActivityModel
/**
 * Model RecordActivity
 * 
 */
export type RecordActivity = Prisma.RecordActivityModel
/**
 * Model Record
 * 
 */
export type Record = Prisma.RecordModel
/**
 * Model RecordUniqueValue
 * 
 */
export type RecordUniqueValue = Prisma.RecordUniqueValueModel
/**
 * Model RecordSelectedOption
 * 
 */
export type RecordSelectedOption = Prisma.RecordSelectedOptionModel
/**
 * Model FieldDefaultOption
 * 
 */
export type FieldDefaultOption = Prisma.FieldDefaultOptionModel
/**
 * Model RelationshipRecord
 * 
 */
export type RelationshipRecord = Prisma.RelationshipRecordModel
/**
 * Model Page
 * 
 */
export type Page = Prisma.PageModel
/**
 * Model MemberNavigationItem
 * 
 */
export type MemberNavigationItem = Prisma.MemberNavigationItemModel
/**
 * Model NavigationItem
 * 
 */
export type NavigationItem = Prisma.NavigationItemModel
/**
 * Model Block
 * 
 */
export type Block = Prisma.BlockModel
/**
 * Model Model
 * 
 */
export type Model = Prisma.ModelModel
/**
 * Model Field
 * 
 */
export type Field = Prisma.FieldModel
/**
 * Model FieldSection
 * Workplace-scoped visualization helper for organizing fields in CRM UI lists.
 * Distinct from form layout FormSection (page blocks).
 */
export type FieldSection = Prisma.FieldSectionModel
/**
 * Model DataNormalization
 * 
 */
export type DataNormalization = Prisma.DataNormalizationModel
/**
 * Model FieldDefinitionNormalization
 * 
 */
export type FieldDefinitionNormalization = Prisma.FieldDefinitionNormalizationModel
/**
 * Model FieldDefinition
 * 
 */
export type FieldDefinition = Prisma.FieldDefinitionModel
/**
 * Model FieldDefinitionOption
 * 
 */
export type FieldDefinitionOption = Prisma.FieldDefinitionOptionModel
/**
 * Model Relationship
 * 
 */
export type Relationship = Prisma.RelationshipModel
/**
 * Model RelationshipLink
 * 
 */
export type RelationshipLink = Prisma.RelationshipLinkModel
/**
 * Model Setting
 * 
 */
export type Setting = Prisma.SettingModel
/**
 * Model TaxRate
 * 
 */
export type TaxRate = Prisma.TaxRateModel
/**
 * Model TaxLine
 * 
 */
export type TaxLine = Prisma.TaxLineModel
/**
 * Model Checkout
 * 
 */
export type Checkout = Prisma.CheckoutModel
/**
 * Model Admission
 * 
 */
export type Admission = Prisma.AdmissionModel
/**
 * Model DependantLineAssignment
 * 
 */
export type DependantLineAssignment = Prisma.DependantLineAssignmentModel
/**
 * Model Line
 * 
 */
export type Line = Prisma.LineModel
/**
 * Model Order
 * 
 */
export type Order = Prisma.OrderModel
/**
 * Model DraftOrder
 * 
 */
export type DraftOrder = Prisma.DraftOrderModel
/**
 * Model TerminalReader
 * 
 */
export type TerminalReader = Prisma.TerminalReaderModel
/**
 * Model Location
 * 
 */
export type Location = Prisma.LocationModel
/**
 * Model Space
 * 
 */
export type Space = Prisma.SpaceModel
/**
 * Model File
 * 
 */
export type File = Prisma.FileModel
/**
 * Model Transaction
 * 
 */
export type Transaction = Prisma.TransactionModel
/**
 * Model Invoice
 * 
 */
export type Invoice = Prisma.InvoiceModel
/**
 * Model InvoiceLine
 * 
 */
export type InvoiceLine = Prisma.InvoiceLineModel
/**
 * Model Refund
 * 
 */
export type Refund = Prisma.RefundModel
/**
 * Model RefundLine
 * 
 */
export type RefundLine = Prisma.RefundLineModel
/**
 * Model Amount
 * 
 */
export type Amount = Prisma.AmountModel
/**
 * Model Payout
 * 
 */
export type Payout = Prisma.PayoutModel
/**
 * Model BalanceTransaction
 * 
 */
export type BalanceTransaction = Prisma.BalanceTransactionModel
/**
 * Model Customer
 * 
 */
export type Customer = Prisma.CustomerModel
/**
 * Model Dependant
 * 
 */
export type Dependant = Prisma.DependantModel
/**
 * Model Image
 * 
 */
export type Image = Prisma.ImageModel
/**
 * Model Service
 * 
 */
export type Service = Prisma.ServiceModel
/**
 * Model NotificationTemplate
 * 
 */
export type NotificationTemplate = Prisma.NotificationTemplateModel
/**
 * Model NotificationTopic
 * 
 */
export type NotificationTopic = Prisma.NotificationTopicModel
/**
 * Model Notification
 * 
 */
export type Notification = Prisma.NotificationModel
/**
 * Model Address
 * 
 */
export type Address = Prisma.AddressModel
/**
 * Model Product
 * 
 */
export type Product = Prisma.ProductModel
/**
 * Model ProductVariant
 * 
 */
export type ProductVariant = Prisma.ProductVariantModel
/**
 * Model Inventory
 * 
 */
export type Inventory = Prisma.InventoryModel
/**
 * Model Member
 * 
 */
export type Member = Prisma.MemberModel
/**
 * Model CliToken
 * CLI authentication token for skedyul CLI
 * Allows developers to authenticate via browser and use the CLI
 */
export type CliToken = Prisma.CliTokenModel
/**
 * Model Contact
 * 
 */
export type Contact = Prisma.ContactModel
/**
 * Model ContactAssociation
 * 
 */
export type ContactAssociation = Prisma.ContactAssociationModel
/**
 * Model ContactBlock
 * Timeline blocks scoped to a contact and merged into all of the contact's threads at read time.
 */
export type ContactBlock = Prisma.ContactBlockModel
/**
 * Model App
 * 
 */
export type App = Prisma.AppModel
/**
 * Model Deployment
 * 
 */
export type Deployment = Prisma.DeploymentModel
/**
 * Model DeploymentWorkflowVersion
 * Join table linking deployments to their bundled workflow versions
 * Allows reusing unchanged workflow versions across deployments
 */
export type DeploymentWorkflowVersion = Prisma.DeploymentWorkflowVersionModel
/**
 * Model PendingDeployment
 * Outbox table for reliable deployment processing.
 * Deployments are written here within a transaction, then processed
 * by a scheduled workflow that polls every 5 seconds.
 */
export type PendingDeployment = Prisma.PendingDeploymentModel
/**
 * Model Executable
 * Unified logical executable unit for apps and workflows.
 * Exactly one of appId or workflowVersionId should be non-null.
 */
export type Executable = Prisma.ExecutableModel
/**
 * Model AppInstallation
 * 
 */
export type AppInstallation = Prisma.AppInstallationModel
/**
 * Model AppInstallSetupStep
 * Per-install setup checklist step seeded from provision.setup
 */
export type AppInstallSetupStep = Prisma.AppInstallSetupStepModel
/**
 * Model AppCrmMap
 * Install-time CRM map for an app entity (not a shared model).
 * Workplaces configure entity → CRM model/field mappings; workflows apply via Liquid.
 */
export type AppCrmMap = Prisma.AppCrmMapModel
/**
 * Model CommunicationChannel
 * 
 */
export type CommunicationChannel = Prisma.CommunicationChannelModel
/**
 * Model AppField
 * 
 */
export type AppField = Prisma.AppFieldModel
/**
 * Model AppModel
 * 
 */
export type AppModel = Prisma.AppModelModel
/**
 * Model CommunicationChannelSubscription
 * 
 */
export type CommunicationChannelSubscription = Prisma.CommunicationChannelSubscriptionModel
/**
 * Model EnvVariable
 * Environment variables scoped to communication channels, triggers, or app installations
 * Supports multiple scopes simultaneously. When merging, priority is: trigger > communicationChannel > appInstall > AppEnvironment/AppVersion > global
 * Note: label and description are now stored in Executable.config
 */
export type EnvVariable = Prisma.EnvVariableModel
/**
 * Model AppVersion
 * 
 */
export type AppVersion = Prisma.AppVersionModel
/**
 * Model AppAccess
 * Grants a workplace access to an unpublished app.
 * For published apps (publishedAt IS NOT NULL), all workplaces have access.
 * For unpublished apps, only the owner and whitelisted workplaces can access.
 */
export type AppAccess = Prisma.AppAccessModel
/**
 * Model AppResource
 * Defines all resources an app version provides (models, fields, channels, workflows, etc.)
 * This is the version-level definition - instances are created per-installation.
 */
export type AppResource = Prisma.AppResourceModel
/**
 * Model AppResourceDependency
 * Junction table for resource dependencies.
 * Defines what resources depend on other resources.
 */
export type AppResourceDependency = Prisma.AppResourceDependencyModel
/**
 * Model AppResourceInstance
 * Per-installation instance of an app resource, or version-level instance for INTERNAL resources.
 * - For SHARED resources: appInstallationId is set, maps to user's resource per installation
 * - For INTERNAL resources: appInstallationId is NULL, maps to version-level Model/Field/Relationship
 */
export type AppResourceInstance = Prisma.AppResourceInstanceModel
/**
 * Model DedicatedPhoneNumber
 * 
 */
export type DedicatedPhoneNumber = Prisma.DedicatedPhoneNumberModel
/**
 * Model Chat
 * 
 */
export type Chat = Prisma.ChatModel
/**
 * Model ChatMessage
 * 
 */
export type ChatMessage = Prisma.ChatMessageModel
/**
 * Model Tool
 * Unified tool abstraction. Tools may be backed by executables, workflows, or CRM models.
 */
export type Tool = Prisma.ToolModel
/**
 * Model AgentRun
 * Execution trace for a single agent turn.
 */
export type AgentRun = Prisma.AgentRunModel
/**
 * Model ToolCall
 * Individual tool invocation as part of an AgentRun.
 */
export type ToolCall = Prisma.ToolCallModel
/**
 * Model MessageAttachment
 * 
 */
export type MessageAttachment = Prisma.MessageAttachmentModel
/**
 * Model WorkflowVersion
 * 
 */
export type WorkflowVersion = Prisma.WorkflowVersionModel
/**
 * Model AppVersionWorkflowVersion
 * Links WorkflowVersions to the AppVersion they were provisioned for.
 * Enables Dev and Prod AppVersions to have different active workflow versions.
 * Triggers can point to any WorkflowVersion that has been provisioned for their app.
 */
export type AppVersionWorkflowVersion = Prisma.AppVersionWorkflowVersionModel
/**
 * Model ChatReadCursor
 * 
 */
export type ChatReadCursor = Prisma.ChatReadCursorModel
/**
 * Model MemberInboxCursor
 * 
 */
export type MemberInboxCursor = Prisma.MemberInboxCursorModel
/**
 * Model Webhook
 * 
 */
export type Webhook = Prisma.WebhookModel
/**
 * Model WebhookRegistration
 * Individual webhook registration - an active instance of a webhook handler
 * Token-based URLs (whkr_xxx) for external services to call
 */
export type WebhookRegistration = Prisma.WebhookRegistrationModel
/**
 * Model CronCursor
 * Stores pagination cursors per installation + cursor key
 * Multiple cron subscriptions can share the same cursor via cursorKey
 */
export type CronCursor = Prisma.CronCursorModel
/**
 * Model CronSubscription
 * Per-installation subscription to run a tool on a schedule
 * Crons are just scheduled tool invocations
 */
export type CronSubscription = Prisma.CronSubscriptionModel
/**
 * Model EventListener
 * @deprecated Use Trigger with type=HOOK instead. EventListener will be removed in a future version.
 * This model is kept for backwards compatibility during migration.
 */
export type EventListener = Prisma.EventListenerModel
/**
 * Model Workflow
 * 
 */
export type Workflow = Prisma.WorkflowModel
/**
 * Model WorkflowRun
 * 
 */
export type WorkflowRun = Prisma.WorkflowRunModel
/**
 * Model WorkflowRunStep
 * 
 */
export type WorkflowRunStep = Prisma.WorkflowRunStepModel
/**
 * Model Agent
 * 
 */
export type Agent = Prisma.AgentModel
/**
 * Model AgentVersion
 * Versioned agent configuration stored in database.
 * Enables A/B testing, rollback, and draft/published workflow.
 */
export type AgentVersion = Prisma.AgentVersionModel
/**
 * Model Skill
 * Skill identity - stable reference for agents
 */
export type Skill = Prisma.SkillModel
/**
 * Model SkillVersion
 * Versioned skill content - enables A/B testing and rollback
 */
export type SkillVersion = Prisma.SkillVersionModel
/**
 * Model AgentConversation
 * @deprecated Use Thread with kind=INTERNAL instead.
 * Persistent agent conversation per workplace and tab.
 * This model is being replaced by the unified Thread system.
 * Migration: Create INTERNAL threads with sessionId = tabId.
 */
export type AgentConversation = Prisma.AgentConversationModel
/**
 * Model AgentConversationMessage
 * @deprecated Use ThreadMessage with contentStructured instead.
 * Messages within an agent conversation.
 * This model is being replaced by ThreadMessage with contentStructured JSON field.
 */
export type AgentConversationMessage = Prisma.AgentConversationMessageModel
/**
 * Model AgentContext
 * Tracks contextual items referenced during a conversation for context resolution.
 * Enables the agent to resolve references like "him", "that customer", "this workflow" without redundant lookups.
 */
export type AgentContext = Prisma.AgentContextModel
/**
 * Model Trigger
 * 
 */
export type Trigger = Prisma.TriggerModel
/**
 * Model TriggerEvent
 * 
 */
export type TriggerEvent = Prisma.TriggerEventModel
/**
 * Model PageComponent
 * 
 */
export type PageComponent = Prisma.PageComponentModel
/**
 * Model BatchJob
 * 
 */
export type BatchJob = Prisma.BatchJobModel
/**
 * Model Action
 * 
 */
export type Action = Prisma.ActionModel
/**
 * Model CustomResourceModel
 * 
 */
export type CustomResourceModel = Prisma.CustomResourceModelModel
/**
 * Model CustomResource
 * 
 */
export type CustomResource = Prisma.CustomResourceModel
/**
 * Model Campaign
 * 
 */
export type Campaign = Prisma.CampaignModel
/**
 * Model CampaignGoal
 * 
 */
export type CampaignGoal = Prisma.CampaignGoalModel
/**
 * Model CampaignParticipant
 * 
 */
export type CampaignParticipant = Prisma.CampaignParticipantModel
/**
 * Model Metafield
 * 
 */
export type Metafield = Prisma.MetafieldModel
/**
 * Model MetafieldValue
 * 
 */
export type MetafieldValue = Prisma.MetafieldValueModel
/**
 * Model MetafieldDefinition
 * 
 */
export type MetafieldDefinition = Prisma.MetafieldDefinitionModel
/**
 * Model MetafieldDefinitionOption
 * 
 */
export type MetafieldDefinitionOption = Prisma.MetafieldDefinitionOptionModel
/**
 * Model InputType
 * 
 */
export type InputType = Prisma.InputTypeModel
/**
 * Model Import
 * 
 */
export type Import = Prisma.ImportModel
/**
 * Model ImportRow
 * 
 */
export type ImportRow = Prisma.ImportRowModel
/**
 * Model Migration
 * 
 */
export type Migration = Prisma.MigrationModel
/**
 * Model WorkplaceMigration
 * 
 */
export type WorkplaceMigration = Prisma.WorkplaceMigrationModel
/**
 * Model LlmProvider
 * LLM Provider configuration - can be system-provided or user-added
 * System providers (system=true) are built-in and available to all workplaces
 * User providers (system=false) belong to a specific workplace
 */
export type LlmProvider = Prisma.LlmProviderModel
/**
 * Model LlmModel
 * Stores configuration for supported LLM models
 */
export type LlmModel = Prisma.LlmModelModel
/**
 * Model LlmUsage
 * Tracks LLM usage for billing and analytics
 */
export type LlmUsage = Prisma.LlmUsageModel
/**
 * Model Provision
 * Tracks the provisioning process for assigning an Executable to an AppVersion.
 * Provides real-time visibility into provisioning steps for the UI sidebar.
 */
export type Provision = Prisma.ProvisionModel
/**
 * Model ReportDefinition
 * Report template definitions parsed from YAML files.
 * Each definition represents a reusable report template.
 */
export type ReportDefinition = Prisma.ReportDefinitionModel
/**
 * Model CRMMigration
 * Tracks CRM schema migrations with full audit trail, approval workflow, and rollback capability.
 * Every schema change (UI, API, app deploys) creates a CRMMigration record.
 */
export type CRMMigration = Prisma.CRMMigrationModel
/**
 * Model CRMOperation
 * Individual atomic operations within a CRMMigration.
 * Each operation has before/after state snapshots for rollback.
 */
export type CRMOperation = Prisma.CRMOperationModel
/**
 * Model ThreadWorkflowRun
 * Tracks workflows running on a thread.
 * Enables coordination like cancelling a cadence when a customer replies.
 */
export type ThreadWorkflowRun = Prisma.ThreadWorkflowRunModel
/**
 * Model Participant
 * Unified identity for all conversation participants.
 * Polymorphic: exactly one of contactId, memberId, agentId should be set (or none for SYSTEM).
 */
export type Participant = Prisma.ParticipantModel
/**
 * Model Thread
 * Conversation container replacing Chat.
 * Supports sub-threads via parentId for escalations and internal discussions.
 */
export type Thread = Prisma.ThreadModel
/**
 * Model ThreadParticipant
 * Membership tracking for thread participants with roles and visibility.
 */
export type ThreadParticipant = Prisma.ThreadParticipantModel
/**
 * Model ScheduledEvent
 * Scheduled events for follow-ups, reminders, etc.
 * Processed by Vercel cron job and batched to Temporal
 */
export type ScheduledEvent = Prisma.ScheduledEventModel
/**
 * Model ScheduledMessage
 * Scheduled messages for future delivery.
 * Processed by processScheduledMessagesWorkflow in Temporal.
 */
export type ScheduledMessage = Prisma.ScheduledMessageModel
/**
 * Model ThreadMessage
 * Individual message in a thread.
 */
export type ThreadMessage = Prisma.ThreadMessageModel
/**
 * Model ThreadMessageAttachment
 * Attachment for thread messages (separate from ChatMessage attachments).
 */
export type ThreadMessageAttachment = Prisma.ThreadMessageAttachmentModel
/**
 * Model MessageOutbox
 * Outbox for async message delivery to external channels.
 * Messages written here are processed by processMessageOutboxWorkflow.
 * invokeUrl is NOT stored - resolved at runtime from appInstallationId.
 */
export type MessageOutbox = Prisma.MessageOutboxModel
/**
 * Model MessageInbox
 * Inbox for async processing of inbound messages from webhooks.
 * Minimal capture - stores raw webhook data for fast webhook response.
 * Heavy processing (thread/contact creation) deferred to processMessageInboxWorkflow.
 */
export type MessageInbox = Prisma.MessageInboxModel
/**
 * Model Event
 * Generic system event for the event bus.
 * Events are emitted by various system components and processed by subscribed agents/workflows.
 * Uses outbox pattern: events written with status=PENDING, claimed and processed by eventDispatcherWorkflow.
 */
export type Event = Prisma.EventModel
/**
 * Model EventSubscription
 * Subscription to system events for agents or workflow triggers.
 * Enables agents and workflows to react to events with optional condition filtering.
 */
export type EventSubscription = Prisma.EventSubscriptionModel
/**
 * Model ThreadBlock
 * Unified timeline block for threads.
 * Single source of truth for all timeline items: messages, reasoning, tool calls, workflows, sub-threads, and thread links.
 * Enables participant-based rendering and built-in approval workflow for tool calls.
 */
export type ThreadBlock = Prisma.ThreadBlockModel
/**
 * Model ThreadReadCursor
 * Tracks read position per participant in a thread.
 */
export type ThreadReadCursor = Prisma.ThreadReadCursorModel
/**
 * Model ThreadContext
 * Links a Thread to an external communication channel.
 * Links threads to external entities (CRM records, other threads, documents).
 */
export type ThreadContext = Prisma.ThreadContextModel
/**
 * Model ThreadLink
 * For active cross-thread conversations (agent consulting another thread).
 */
export type ThreadLink = Prisma.ThreadLinkModel
/**
 * Model ThreadTopic
 * High-level categories that messages can belong to.
 */
export type ThreadTopic = Prisma.ThreadTopicModel
/**
 * Model MessageTopic
 * Association between messages and topics
 */
export type MessageTopic = Prisma.MessageTopicModel
/**
 * Model MessageTag
 * Flexible labels for messages
 */
export type MessageTag = Prisma.MessageTagModel
/**
 * Model MessageTagAssignment
 * Association between messages and tags
 */
export type MessageTagAssignment = Prisma.MessageTagAssignmentModel
/**
 * Model DecisionType
 * Configurable decision types per workplace that enable automation triggers.
 */
export type DecisionType = Prisma.DecisionTypeModel
/**
 * Model ThreadDecision
 * Important outcomes extracted from conversations.
 */
export type ThreadDecision = Prisma.ThreadDecisionModel
/**
 * Model ThreadSummary
 * Rolling summaries for threads.
 */
export type ThreadSummary = Prisma.ThreadSummaryModel
/**
 * Model MessageEmbedding
 * Vector embedding for semantic search on messages.
 * Note: The actual vector column uses pgvector extension and is managed via raw SQL.
 */
export type MessageEmbedding = Prisma.MessageEmbeddingModel
/**
 * Model CallSession
 * Voice/video call session within a thread.
 */
export type CallSession = Prisma.CallSessionModel
/**
 * Model CallParticipant
 * Participant in a call session.
 */
export type CallParticipant = Prisma.CallParticipantModel
/**
 * Model MessageReaction
 * Reaction to a message.
 */
export type MessageReaction = Prisma.MessageReactionModel
/**
 * Model MessageMention
 * Mention of a participant in a message.
 */
export type MessageMention = Prisma.MessageMentionModel
